import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, MailIcon, CheckIcon } from 'lucide-react';
import { Logo } from '../brand/Logo';
import { Button } from '../ui/Button';
import { SERVICE_LINES } from '../../data/services';
import { submitLead } from '../../lib/leads';
import { LINKEDIN_URL, CONTACT_EMAIL } from '../../lib/seo';
const COMPANY_FACTS = ['Cavalla Solution is a consulting firm in augmented intelligence, market intelligence and data led growth.'];
export function Footer() {
  const [email, setEmail] = React.useState('');
  const [status, setStatus] = React.useState<'idle' | 'sending' | 'done'>('idle');
  const [error, setError] = React.useState<string | null>(null);
  const onSubscribe = async (event: React.FormEvent) => {
    event.preventDefault();
    setStatus('sending');
    setError(null);
    const result = await submitLead({
      email,
      consent: true,
      source: 'footer-newsletter'
    });
    if (!result.ok) {
      setError(result.error ?? 'Something went wrong. Please try again.');
      setStatus('idle');
      return;
    }
    setStatus('done');
  };
  return <footer className="surface-dark text-white" data-id="element-109" data-mp="2p4cypwut5fsn">
      <div className="mx-auto w-full max-w-6xl px-5 py-16 sm:px-8 sm:py-20" data-id="element-110" data-mp="2p54jecmv9t45">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]" data-id="element-111" data-mp="2bdpwhupu97rt">
          <div data-id="element-112" data-mp="2gazsjt7qghom">
            <Logo variant="reversed" data-id="element-113" data-mp="2gckptqlfmeq6" />
            <p className="mt-6 max-w-xs text-[15px] text-white/70" data-id="element-114" data-mp="2g9f32i09zoxm">
              Evidence first consulting for organisations that have to make the decision, not just discuss it.
            </p>
            <div className="mt-6 flex items-center gap-4" data-id="element-115" data-mp="380l4r2vn9up0">
              <a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer" className="text-white/70 transition-colors hover:text-gold" aria-label="Cavalla Solution on LinkedIn, opens in a new tab" data-id="element-116" data-mp="2u1uxwvj0wgng">
                <LinkedinIcon className="h-5 w-5" aria-hidden="true" data-id="element-117" data-mp="1nnvl7hl63r9o" />
              </a>
              <a href={`mailto:${CONTACT_EMAIL}`} className="text-white/70 transition-colors hover:text-gold" aria-label="Email Cavalla Solution" data-id="element-118" data-mp="13kzemmckp2ww">
                <MailIcon className="h-5 w-5" aria-hidden="true" data-id="element-119" data-mp="ure279nvrxqn" />
              </a>
            </div>
          </div>

          <nav aria-label="Services" data-id="element-120" data-mp="pstaxzqlwoec">
            <h2 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-121" data-mp="ku89jwzmbyob">Services</h2>
            <ul className="mt-5 space-y-3 text-[15px] text-white/75" data-id="element-122" data-mp="fv54wdnjvugv">
              {SERVICE_LINES.map(line => <li key={line.id} data-id="element-123" data-mp="bt1r3idesdsf">
                  <Link to={`/services/${line.id}`} className="transition-colors hover:text-white" data-id="element-124" data-mp="bu3dgizvkmpg">
                    {line.name}
                  </Link>
                </li>)}
              <li data-id="element-125" data-mp="2669sjsvw3nn1">
                <Link to="/cavalla-gov" className="transition-colors hover:text-white" data-id="element-126" data-mp="266t5swalhnuq">
                  Cavalla Gov
                </Link>
              </li>
              <li data-id="element-127" data-mp="28sshkmlk64kv">
                <Link to="/augmented-intelligence" className="transition-colors hover:text-white" data-id="element-128" data-mp="28r7m8urf6hly">
                  Our method
                </Link>
              </li>
              <li data-id="element-129" data-mp="2ihajj75kqhq3">
                <Link to="/assessment" className="transition-colors hover:text-white" data-id="element-130" data-mp="2ij52ifxabzrj">
                  AI readiness assessment
                </Link>
              </li>
            </ul>
          </nav>

          <nav aria-label="Company" data-id="element-131" data-mp="1pug9732h0yqc">
            <h2 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-132" data-mp="1pvhlfav83r9n">Company</h2>
            <ul className="mt-5 space-y-3 text-[15px] text-white/75" data-id="element-133" data-mp="1uu2l996kc8xk">
              <li data-id="element-134" data-mp="1zprhb2jdj7p4"><Link to="/insights" className="transition-colors hover:text-white" data-id="element-135" data-mp="1zq14yjgy52rn">Insights</Link></li>
              <li data-id="element-136" data-mp="23u8z4w66bax9"><Link to="/webinars" className="transition-colors hover:text-white" data-id="element-137" data-mp="23u8ugiv8amqx">Webinars</Link></li>
              <li data-id="element-138" data-mp="3b8keb7wrxwoi"><Link to="/resources" className="transition-colors hover:text-white" data-id="element-139" data-mp="3b8kcr3h4lome">Resources</Link></li>
              <li data-id="element-140" data-mp="3f9xkxk7oy3wh"><Link to="/about" className="transition-colors hover:text-white" data-id="element-141" data-mp="3f9xmhoncabyl">About</Link></li>
              <li data-id="element-142" data-mp="3dsqse8f3r3is"><Link to="/contact" className="transition-colors hover:text-white" data-id="element-143" data-mp="3dsqqu3zgevgo">Contact</Link></li>
              <li data-id="element-144" data-mp="38u7626wljppw"><Link to="/portal/login" className="transition-colors hover:text-white" data-id="element-145" data-mp="3np3kx2ywvbby">Client login</Link></li>
            </ul>
          </nav>

          <div data-id="element-146" data-mp="3ioz1b42pi0hi">
            <h2 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-147" data-mp="3iofkjqosli52">Fortnightly brief</h2>
            <p className="mt-5 text-[15px] text-white/70" data-id="element-148" data-mp="ikstkn7iiqi">
              One email every two weeks. Market movement, AI adoption and what it means for your sector.
            </p>
            {status === 'done' ? <p className="mt-5 flex items-center gap-2 text-[15px] text-white" data-id="element-149" data-mp="ac1iqdk83dow">
                <CheckIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-150" data-mp="5bvxbf4jqnf9" />
                You are subscribed. Thank you.
              </p> : <form onSubmit={onSubscribe} className="mt-5" data-id="element-151" data-mp="fa35b8guxv54">
                <label htmlFor="footer-email" className="sr-only" data-id="element-152" data-mp="xxklupq83hic">
                  Your email address
                </label>
                <div className="flex flex-col gap-2 sm:flex-row" data-id="element-153" data-mp="12wx8pah3gokx">
                  <input id="footer-email" type="email" required value={email} onChange={event => setEmail(event.target.value)} placeholder="you@organisation.org" aria-describedby={error ? 'footer-email-error' : undefined} className="w-full rounded-sm border border-white/25 bg-white/5 px-3 py-2.5 text-[15px] text-white placeholder:text-white/40" data-id="element-154" data-mp="12uayt46qdwzj" />
                  <Button type="submit" size="sm" disabled={status === 'sending'} className="shrink-0" data-id="element-155" data-mp="a785qrktqego">
                    {status === 'sending' ? 'Sending' : 'Subscribe'}
                  </Button>
                </div>
                {error && <p id="footer-email-error" role="alert" className="mt-2 text-small text-gold" data-id="element-156" data-mp="19ealjyspqv3">
                    {error}
                  </p>}
                <p className="mt-3 text-small text-white/50" data-id="element-157" data-mp="1y4pofdp3apzf">
                  We handle your data in line with our{' '}
                  <Link to="/legal/privacy" className="underline underline-offset-2 hover:text-white" data-id="element-158" data-mp="1u4f9hbjbkp8f">
                    privacy notice
                  </Link>
                  .
                </p>
              </form>}
          </div>
        </div>

        <div className="mt-14 border-t border-white/12 pt-8" data-id="element-159" data-mp="2hti19c7o3ygn">
          <h2 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-white/40" data-id="element-160" data-mp="2cuolfd4wrvdb">
            About Cavalla Solution
          </h2>
          <ul className="mt-3 space-y-1.5 text-small text-white/45" data-id="element-161" data-mp="27uir1p797urj">
            {COMPANY_FACTS.map(fact => <li key={fact} data-id="element-162" data-mp="11h2xtwep61tw">{fact}</li>)}
          </ul>
        </div>

        <div className="mt-8 flex flex-col gap-4 border-t border-white/12 pt-8 text-small text-white/50 sm:flex-row sm:items-center sm:justify-between" data-id="element-163" data-mp="wfdja6s9n612">
          <p data-id="element-164" data-mp="manhc0wv41wu">Copyright {new Date().getFullYear()} Cavalla Solution. All rights reserved.</p>
          <nav aria-label="Legal" className="flex flex-wrap gap-5" data-id="element-165" data-mp="r98f7ton69i4">
            <Link to="/legal/privacy" className="hover:text-white" data-id="element-166" data-mp="w937o1o2f75a">Privacy</Link>
            <Link to="/legal/terms" className="hover:text-white" data-id="element-167" data-mp="112ft62xg6xtt">Terms</Link>
            <Link to="/legal/cookies" className="hover:text-white" data-id="element-168" data-mp="153hj1t5h5xj4">Cookies</Link>
          </nav>
        </div>
      </div>
    </footer>;
}